import { Grid, Paper, Typography } from '@mui/material'
import { memo } from 'react'
import { monthNames, weekNames } from '../../util/general'
import { formatLargeNumber } from '../../util/screener'
import { participantBarDefaultColor } from './OIChart'
import { BarLabelView } from '../../components/participantOpenInterest/BarLabel'

type TooltipProps = {
    colors: Map<string, string>,
    data: { data: { date: string } & any, leftScaleData: { date: string } & any },
    keys: string[],
    leftScaleKeys: string[],
    specificColors?: { [key: string]: (value: string) => string }
}

export const ToolTipView = memo(({ colors, data, keys, leftScaleKeys, specificColors }: TooltipProps) => {
    const date = data.data.date

    return (<Paper
        sx={{ padding: 1, margin: 0, backgroundColor: (theme) => theme.palette.background.default }}>
        <Grid item gap={2}>
            <Typography
                variant={'body2'}>Strike {date}</Typography>
            {
                keys.map((key) => {
                    const value = data.data[key]
                    const color = specificColors && specificColors[key] ? specificColors[key](value) : colors.get(key) ?? participantBarDefaultColor
                    return (
                        <Grid container gap={2} width={'100%'} justifyContent="space-between" alignItems="center">
                            <BarLabelView label={key} color={color} />
                            <Typography variant={'body2'}>{formatLargeNumber(value, 0)}</Typography>
                        </Grid>)
                })
            }
            {
                data.leftScaleData && leftScaleKeys.map((key) => {
                    return (
                        <Grid width={'100%'} container gap={2} justifyContent="space-between" alignItems="center">
                            <BarLabelView label={key} color={colors.get(key) ?? participantBarDefaultColor} />
                            <Typography variant={'body2'}>{data.leftScaleData[key].toFixed(2)}</Typography>
                        </Grid>)
                })
            }
        </Grid>
    </Paper>)
})